import { publishErrorToDatadog } from './publish';

export const logError = (...errors: Parameters<typeof console.error>) => {
  const [firstError = {}, ...otherErrors] = errors;
  console.error(
    firstError.stack ||
      firstError.message ||
      firstError.data?.message ||
      firstError,
    ...otherErrors,
  );
  publishErrorToDatadog(
    errors.map((error) => {
      if (error?.headers instanceof Headers) {
        return {
          ...error,
          headers: Object.fromEntries(error.headers.entries()),
        };
      }
      return error;
    }),
  );
};

export const logWarning = (...warnings: Parameters<typeof console.warn>) => {
  console.warn(...warnings);
};
